import Vue from 'vue';
import App from './App';
import Vuetify from 'vuetify';
import router from './router';
import store from './store';

import 'font-awesome/css/font-awesome.css';
import './theme/default.styl';
import VeeValidate from 'vee-validate';
import Truncate from 'lodash.truncate';

import Vue2Leaflet from 'vue2-leaflet';
import 'leaflet-rotatedmarker';
import 'leaflet/dist/leaflet.css';
import '@/utils/googleapis/googlemap.js';
import '@/utils/googleapis/googlefonts.css';
Vue.prototype.$leaflet = window.L; // Lưu cục bộ leaflet

setTimeout(() => {
  window.L = Vue.prototype.$leaflet;
  require('leaflet.markercluster');
  require('leaflet.markercluster/dist/MarkerCluster.css');
  require('leaflet.markercluster/dist/MarkerCluster.Default.css');
}, 1000); // Settimeout tạm thời -> xử lý việc leaflet.markercluster load trước leaflet

if (window.location.href.includes('location') || window.location.protocol.includes('https')) import('./register-service-worker');

Vue.config.productionTip = false;
Vue.filter('truncate', Truncate);
Vue.use(VeeValidate, { fieldsBagName: 'formFields' });


Vue.use(Vuetify, {
  options: {
    themeVariations: ['primary', 'secondary', 'accent'],
    extra: {
      mainToolbar: {
        color: 'primary'
      },
      sideToolbar: {},
      sideNav: 'primary',
      mainNav: 'primary lighten-1',
      bodyBg: ''
    }
  },
  Vue2Leaflet
});

// eslint-disable-next-line
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js